var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{},[_c('router-view'),_c('v-footer',{attrs:{"app":"","color":"grey lighten-4"}},[_c('span',{staticClass:"ml-4 text-caption"},[_vm._v("© 2018 Management Resources Consultants, All Rights Reserved")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }